import {CustomList} from "../components/CustomList";
import {useOptionsResource} from "../shared/hooks/useOptionsResource";
import {getDefaultListProps, initField} from "../shared/utils";

import {Box, Divider, makeStyles, Paper, Tab, Tabs, Typography} from "@material-ui/core";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import {Fragment, useCallback, useEffect, useState} from "react";
import {
    AutocompleteArrayInput,
    AutocompleteInput,
    Datagrid,
    DatagridProps,
    FunctionField,
    Identifier,
    ListContextProvider,
    ListProps,
    ReferenceArrayInput,
    ReferenceInput, SelectInput,
    TextField,
    TextInput,
    useListContext, useResourceContext,
} from "react-admin";
import {IdentifierField} from "../components/IdentifierField";
import {getUser} from "../authProvider";
import {EmployeePhotoFromBase64} from "../components/EmployeePhotoFromBase64";
import {useListQueryParams} from "../shared/hooks/useListQueryParams";
import {stringify} from "querystring";
import {useQuery} from "react-query";
import {client} from "../dataProvider";

const tabs = [
    {id: null, name: "Tutti"},
    {id: "Autista", name: "Autisti"},
    {id: "Ufficio", name: "Ufficio"},
    {id: "Magazzino", name: "Magazzino"},
    {id: "Manutenzione", name: "Manutenzione"},
    {id: "Smistamento", name: "Smistamento"},
];

const TabbedDatagrid = (props: DatagridProps) => {
    const listContext = useListContext();
    const {ids, filterValues, setFilters, displayedFilters} = listContext;
    const [all, setAll] = useState<Identifier[]>([] as Identifier[]);
    const [drivers, setDrivers] = useState<Identifier[]>([] as Identifier[]);
    const [office, setOffice] = useState<Identifier[]>([] as Identifier[]);
    const [mainteneance, setMaintenance] = useState<Identifier[]>(
        [] as Identifier[]
    );
    const [store, setStore] = useState<Identifier[]>([] as Identifier[]);
    const [sorting, setSorting] = useState<Identifier[]>([] as Identifier[]);

    useEffect(() => {
        if (ids && ids !== filterValues.departments) {
            switch (filterValues.departments) {
                case null:
                    setAll(ids);
                    break;
                case "Autista":
                    setDrivers(ids);
                    break;
                case "Ufficio":
                    setOffice(ids);
                    break;
                case "Magazzino":
                    setStore(ids);
                    break;
                case "Manutenzione":
                    setMaintenance(ids);
                    break;
                case "Smistamento":
                    setSorting(ids);
                    break;
            }
        }
    }, [ids, filterValues.departments]);

    const handleChange = useCallback(
        (event: React.ChangeEvent<{}>, value: any) => {
            setFilters &&
            setFilters({...filterValues, departments: value}, displayedFilters);
        },
        [displayedFilters, filterValues, setFilters]
    );
    const {data: options} = useOptionsResource("GET");

    return (
        <Fragment>
            <Tabs
                variant="fullWidth"
                centered
                value={filterValues.departments}
                indicatorColor="primary"
                onChange={handleChange}
            >
                {tabs.map((choice) => (
                    <Tab key={choice.id} label={choice.name} value={choice.id}/>
                ))}
            </Tabs>
            <Divider/>
            {options ? (
                <div>
                    {(filterValues.departments == null ||
                        filterValues.departments == undefined ||
                        filterValues.departments == ""
                    ) && (
                        <ListContextProvider value={{...listContext, ids: all}}>
                            <Datagrid {...props}>
                                <IdentifierField {...initField("id", options)} />
                                <TextField {...initField("name", options)} />
                                <TextField {...initField("surname", options)} />
                                <TextField {...initField("sites__business_name", options)} label="Sedi"/>
                            </Datagrid>
                        </ListContextProvider>
                    )}
                    {filterValues.departments === "Autista" && (
                        <ListContextProvider value={{...listContext, ids: drivers}}>
                            <Datagrid {...props}>
                                <IdentifierField {...initField("id", options)} />
                                <TextField {...initField("name", options)} />
                                <TextField {...initField("surname", options)} />
                                <TextField {...initField("license", options)} />
                                <TextField {...initField("device", options)} />
                                <TextField {...initField("fuel_card_number", options)} />
                            </Datagrid>
                        </ListContextProvider>
                    )}
                    {filterValues.departments === "Ufficio" && (
                        <ListContextProvider value={{...listContext, ids: office}}>
                            <Datagrid {...props}>
                                <IdentifierField {...initField("id", options)} />
                                <TextField {...initField("name", options)} />
                                <TextField {...initField("surname", options)} />
                                <TextField {...initField("phone_number", options)} />
                                <TextField {...initField("email", options)} />
                            </Datagrid>
                        </ListContextProvider>
                    )}
                    {filterValues.departments === "Magazzino" && (
                        <ListContextProvider value={{...listContext, ids: store}}>
                            <Datagrid {...props}>
                                <IdentifierField {...initField("id", options)} />
                                <TextField {...initField("name", options)} />
                                <TextField {...initField("surname", options)} />
                                <TextField {...initField("phone_number", options)} />
                                <TextField {...initField("email", options)} />
                            </Datagrid>
                        </ListContextProvider>
                    )}
                    {filterValues.departments === "Manutenzione" && (
                        <ListContextProvider value={{...listContext, ids: mainteneance}}>
                            <Datagrid {...props}>
                                <IdentifierField {...initField("id", options)} />
                                <TextField {...initField("name", options)} />
                                <TextField {...initField("surname", options)} />
                                <TextField {...initField("phone_number", options)} />
                                <TextField {...initField("email", options)} />
                            </Datagrid>
                        </ListContextProvider>
                    )}
                    {filterValues.departments === "Smistamento" && (
                        <ListContextProvider value={{...listContext, ids: sorting}}>
                            <Datagrid {...props}>
                                <IdentifierField {...initField("id", options)} />
                                <TextField {...initField("name", options)} />
                                <TextField {...initField("surname", options)} />
                                <TextField {...initField("phone_number", options)} />
                                <TextField {...initField("email", options)} />
                            </Datagrid>
                        </ListContextProvider>
                    )}
                </div>
            ) : null}
        </Fragment>
    );
};


const useEmployeeHeaderStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1.5, 2),
        marginBottom: theme.spacing(1),
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: 76,
    },
    icon: {
        width: 44,
        height: 44,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: theme.spacing(1.5),
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light,
    },
    value: {
        fontWeight: 700,
        color: theme.palette.primary.main,
        fontVariantNumeric: "tabular-nums",
        lineHeight: 1,
    },
}));

const EmployeeHeader = () => {
    const classes = useEmployeeHeaderStyles();
    const resource = useResourceContext();
    const query = useListQueryParams();
    const url = `${resource}/statistics/?${stringify(query)}`;
    const { data: stats } = useQuery(
        [url],
        () => client(url, { method: "GET" }),
        {
            initialData: {
                tot_employee: 0
            }
        }
    );

    const totalEmployees = Number(stats?.tot_employee) || 0;

    return (
        <Paper className={classes.root} elevation={1}>
            <Box display="flex" alignItems="center">
                <Box className={classes.icon} aria-hidden="true">
                    <PeopleOutlineIcon />
                </Box>
                <Box>
                    <Typography variant="subtitle1" component="h2">
                        Dipendenti
                    </Typography>
                </Box>
            </Box>
            <Box textAlign="right" aria-live="polite">
                <Typography variant="h4" component="div" className={classes.value}>
                    {totalEmployees.toLocaleString("it-IT")}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                    dipendenti
                </Typography>
            </Box>
        </Paper>
    );
};



const NoTabbedDatagrid = (props: DatagridProps) => {
    const listContext = useListContext();
    const {ids, filterValues, setFilters, displayedFilters} = listContext;

    const [store, setStore] = useState<Identifier[]>([] as Identifier[]);
    const [sorting, setSorting] = useState<Identifier[]>([] as Identifier[]);


    const handleChange = useCallback(
        (event: React.ChangeEvent<{}>, value: any) => {
            setFilters &&
            setFilters({...filterValues, departments: value}, displayedFilters);
        },
        [displayedFilters, filterValues, setFilters]
    );
    const {data: options} = useOptionsResource("GET");

    return (

        <ListContextProvider value={{...listContext, ids: ids}}>
            <Datagrid {...props}>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("name", options)} />
                <TextField {...initField("surname", options)} />
                <TextField {...initField("fiscal_code", options)} />
                <FunctionField
                    label="Reparti" render={
                    (record: any) => {
                        if (record && record.departments) {
                            return record.departments.map(
                                (department: any) => department).join(', ')
                        }
                        return ''

                    }}/>

                <TextField {...initField("sites__business_name", options)} label="Sedi"/>
                <FunctionField
                    label="Foto"
                    render={(user: any) => <EmployeePhotoFromBase64 base64img={user.photo_base64}
                                                                    checkCondition={user}/>}
                />
            </Datagrid>
        </ListContextProvider>
    );
};

export const EmployeeList = (props: ListProps) => {
    const {data: options} = useOptionsResource("GET");
    const filters = options
        ? [
            <TextInput {...initField("name", options)} alwaysOn/>,
            <TextInput {...initField("surname", options)} alwaysOn/>,
            <ReferenceArrayInput alwaysOn
                                 {...initField("sites", options)}
                                 label="Sedi"
                                 reference="autocomplete/site"
            >
                <AutocompleteArrayInput optionText="label"/>
            </ReferenceArrayInput>,
            <ReferenceArrayInput alwaysOn
                                 {...initField("departments", options)}
                                 reference="autocomplete/department"
            >
                <AutocompleteArrayInput optionText="label"/>
            </ReferenceArrayInput>,
            <SelectInput
                {...initField("status", options, "array")}
                choices={[
                    {value: "D", display_name: "Disponibile"},
                    {value: "ND", display_name: "Non disponibile"},
                ]}
                alwaysOn
                className="filter-field-small"
                label="Disponibile"
            />,
        ]
        : [];
    return options && getUser().permissions.includes('employees.change_employee') ? (
        <CustomList
            filterDefaultValues={{
                status: "D"
            }}
            filters={filters}
            {...getDefaultListProps(props)}
            topElement={<EmployeeHeader/>}
        >
            <NoTabbedDatagrid/>
        </CustomList>
    ) : null;
};
